module.exports = __webpack_public_path__ + "img/afrikai_gyogymodok.b46d428b.jpg";